import { render } from "./SwiperWrapper.vue?vue&type=template&id=3f93fac0"
import script from "./SwiperWrapper.vue?vue&type=script&lang=js"
export * from "./SwiperWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__